// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.automations-section {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 12px;
  row-gap: 12px;
  min-width: 0;
}
/*# sourceMappingURL=index.css.map */`, "",{"version":3,"sources":["webpack://./index.less","webpack://./wp_components/PositionAutomation/components/AutomationSection/index.less"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;ACDJ;AACA,oCAAoC","sourcesContent":["@import '../../../../less/variables.less';\n\n.automations-section {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    column-gap: @padding-lg;\n    row-gap: @padding-lg;\n    min-width: 0;\n}",".automations-section {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  column-gap: 12px;\n  row-gap: 12px;\n  min-width: 0;\n}\n/*# sourceMappingURL=index.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
